<template>
  <card>
    <slot name="header">
      <h2 class="card-title card-header">
        Participants
      </h2>
    </slot>

    <table class="table table-hover">
      <tbody>
        <tr
          v-for="participant in participants"
          :key="participant.id"
        >
          <td style="width: 100%;">
            <span class="clickable-paragraph" @click="goToPersonProfile(participant.person_id)">
              {{ participant.name }}
            </span>
            <el-button
              @click="openRemoveBSPModal(participant)"
              class="small"
              v-if="bibleStudy"
              v-show="bibleStudy.status == 'Active' && bibleStudy.user_is_leader"
            >
              <i class="el-icon-close icon-btn" />
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>

    <slot name="footer">
      <i
        class="el-icon-circle-plus icon-btn"
        @click="openAddBSPModal"
        v-if="bibleStudy"
        v-show="bibleStudy.status == 'Active' && bibleStudy.user_is_leader"
      />
    </slot>

    <APM
      :show="modals.addBSPOpen"
      :bible-study="bibleStudy"
      @close="modals.addBSPOpen = false"
    />
    <RPM
      :show="modals.removeBSPOpen"
      :participant="removeParticipant"
      @close="modals.removeBSPOpen = false"
    />
  </card>
</template>

<script>
import { mapState } from 'vuex';
import card from '../../UIComponents/Cards/Card';
import AddParticipantModal from './AddModal';
import RemoveParticipantModal from './RemoveModal';

export default {
    name: 'BibleStudyParticipants',
    components: {
        card,
        APM: AddParticipantModal,
        RPM: RemoveParticipantModal,
    },
    data() {
        return {
            namespace: 'BibleStudies',
            modals: {
                addBSPOpen: false,
                removeBSPOpen: false,
            },
            removeParticipant: null,
        };
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            participants: (state) => state.BibleStudies.bibleStudyParticipants,
        }),
    },
    methods: {
        openAddBSPModal() {
            // Fetch eligible participants into state for Add BSP Modal
            this.$store.dispatch(`${this.namespace}/getEligibleParticipants`,
                { bibleStudyId: this.bibleStudy.id }).then(
                this.modals.addBSPOpen = !this.modals.addBSPOpen
            );
        },
        openRemoveBSPModal(participant) {
            // Obtain selected participant and pass to modal as prop
            this.removeParticipant = participant;
            this.modals.removeBSPOpen = !this.modals.removeBSPOpen;
        },
        getBibleStudyParticipantsById() {
            this.$store.dispatch(`${this.namespace}/getBibleStudyParticipantsById`,
                { bibleStudyId: this.bibleStudy.id });
        },
        goToPersonProfile(id) {
            this.$router.push({ name: 'PersonShow', params: { id } });
        }
    },
    created() {
        this.getBibleStudyParticipantsById();
    },
    props: {
        bibleStudy: Object,
    },
};
</script>
<style>
.small {
    padding: 5px;
    float: right;
}
</style>
